import { type RouteObject } from 'react-router'

import {
  PRODUCT_WATCH_DETAIL_TRANSACTION_PATH,
  PRODUCT_WATCH_TRANSACTION_PATH,
  PRODUCT_WATCH_URL,
} from 'features/product-watch/paths'
import { lazyComponent } from 'routes/lazy-route'

// A factory, not a hoisted const — react-router mutates a `lazy` object while
// resolving it, so two routes sharing one object silently break the second.
const productWatchPage = (): ReturnType<typeof lazyComponent<'ProductWatch'>> =>
  lazyComponent(
    () => import('features/product-watch/Container'),
    'ProductWatch',
  )

export const productWatchRoutes: RouteObject[] = [
  {
    path: PRODUCT_WATCH_URL,
    lazy: productWatchPage(),
    handle: {
      featureKey: PRODUCT_WATCH_URL,
      sentryTransactionPath: PRODUCT_WATCH_TRANSACTION_PATH,
    },
  },
  {
    path: `${PRODUCT_WATCH_URL}/:productWatchId`,
    lazy: productWatchPage(),
    handle: {
      featureKey: PRODUCT_WATCH_URL,
      sentryTransactionPath: PRODUCT_WATCH_DETAIL_TRANSACTION_PATH,
    },
  },
]
